import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export default function SiteHeader() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid={LANDING.navLogo}
          className="flex items-center gap-2 group"
        >
          <span className="w-8 h-8 rounded-md bg-[#0f766e] grid place-items-center text-white">
            <Sparkles className="w-4 h-4" />
          </span>
          <span className="font-display font-semibold text-slate-900 tracking-tight">
            AI Operator <span className="text-[#0f766e]">Hub</span>
          </span>
        </Link>
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            data-testid={LANDING.navAdminBtn}
            onClick={() => navigate("/admin/login")}
            className="text-slate-600 hover:text-slate-900"
          >
            Admin
          </Button>
          <Button
            data-testid={LANDING.heroPrimaryCta}
            onClick={() => navigate("/quiz")}
            className="bg-[#0f766e] hover:bg-[#115e59] text-white"
          >
            Find your tools
          </Button>
        </div>
      </div>
    </header>
  );
}
